import * as React from 'react';

import { Button } from '@acceligentllc/storybook';

import styles from './styles.module.scss';

interface OwnProps {
	isVisible: boolean;
	onEditRates(): void;
	onBulkDelete(): void;
}

type Props = OwnProps;

const MaterialBulkControls: React.FC<Props> = (props) => {
	const { isVisible, onEditRates, onBulkDelete } = props;

	if (!isVisible) {
		return null;
	}

	return (
		<div className={styles.materialBulkControls}>
			<Button
				customStyleClass={styles.action}
				icon="ActionEdit"
				label="Edit Rates"
				onClick={onEditRates}
				style="link"
			/>
			<Button
				customStyleClass={styles.action}
				icon="Delete"
				label="Remove"
				onClick={onBulkDelete}
				style="link"
			/>
		</div>
	);
};

export default React.memo(MaterialBulkControls);
